const Images = {
  logo: require('../assets/img/logo-black.png'),
  logoWhite: require('../assets/img/logo-white2.png'),
  background: require('../assets/img/statBackground.png'),
  emptyCampaign: require('../assets/img/empty-campaign.svg'),
  configureInventory: require('../assets/img/configure-inventory.svg'),
  verifyNetworkUsage: require('../assets/img/verify-network-usage.png'),
  emptyAgeRange: require('../../common/assets/empty-barchart.svg'),
  barGraph: require('../../common/assets/empty-barchart.svg'),
  emptyDemo: require('../../common/assets/empty-demo.svg'),

  history: {
    empty: require('../assets/img/empty-history.svg'),
    error: require('../assets/img/error-history.svg'),
  },
};

export default Images;



// WEBPACK FOOTER //
// ./src/statsradio/themes/Images.js